export function getHeapViews(Module: any) {
  if (Module && typeof Module.ready?.then === 'function') {
  }

  const buffer =
    Module?.HEAPU8?.buffer ??
    Module?.HEAP8?.buffer ??
    Module?.wasmMemory?.buffer ??
    Module?.memory?.buffer ??
    undefined;

  if (!buffer) {
    throw new Error(
      'Emscripten memory buffer not found; перевір флаги збірки (MODULARIZE=1, MINIMAL_RUNTIME=0)',
    );
  }

  return {
    U8: Module.HEAPU8 ?? new Uint8Array(buffer),
    I16: Module.HEAP16 ?? new Int16Array(buffer),
  };
}
